/**
 * Amazon phonetool badge-photo helper.
 *
 * <p>Returns a URL that resolves to an employee's headshot keyed by lowercase
 * login. Broken/unknown aliases resolve to a generic silhouette, so callers do
 * not need to error-handle.
 *
 * <p><b>URL choice</b>: uses the {@code badgephotos.corp.amazon.com} endpoint.
 * The legacy {@code internal-cdn.amazon.com/badgephotos.amazon.com} endpoint
 * was deprecated in June 2026. If phonetool ever moves to a new canonical
 * endpoint again, changing the URL here updates every consumer of
 * {@link badgePhotoUrl} at once — do not inline the string.
 */
const BADGE_PHOTO_BASE_URL = 'https://badgephotos.corp.amazon.com/?uid=';

/**
 * Return a badge-photo URL for the given login. Callers should render this
 * inside an {@code <img>} or Cloudscape's icon slot; no auth or error handling
 * required — phonetool serves a fallback silhouette for unknown aliases.
 *
 * @param login canonical lowercase Amazon alias
 * @returns absolute URL to the badge photo
 */
export const badgePhotoUrl = (login: string): string =>
  `${BADGE_PHOTO_BASE_URL}${encodeURIComponent(login)}`;
